module.exports = __webpack_public_path__ + "img/no-data.29347fde.png";